import { numberMask, phoneMask } from "../../core/utils/validateFields"
import { InputFileWithPreview } from "../FileInput"
import { FormRow, Input, InputTextArea, SelectInput } from "../Form"

export const getInputType = (
  answer,
  onChangeQuestionsInfo,
  onChangeFile,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  control,
  register,
  values,
) => {
  const isMultiple = answer.isMulti === "true" && answer.typeIsMulti === "multiple"

  const valueForm = () => {
    if (
      (answer?.type === "radio" || (answer.type === "select" && !isMultiple)) &&
      values[answer?.id]?.length
    ) {
      return values[answer?.id][0]?.value || values[answer?.id]
    } else {
      return values[answer?.id]
    }
  }

  const commonProps = {
    handleChange: (value) => onChangeQuestionsInfo(answer.type, value, answer?.id, answer),
    options: Array.isArray(answer?.options)
      ? [...new Set(answer.options)].map((item) => ({ value: item, label: item }))
      : [],
    value: valueForm(),
    isMulti:
      answer?.type !== "radio" &&
      ((answer.type === "select" && isMultiple) || answer.type === "checkbox"),
    placeholder: "Selecione",
  }

  const handleRemoveFile = (files) => {
    console.log(files)
  }

  const formatFiles = (values, answer) => {
    const answerId = answer?.id;
    const value = values[answerId];
  
    if (Array.isArray(value)) {
      return value.map(item => item.value);
    }
  
    if (typeof value === "object" && value?.value?.includes("file")) {
      return value.value.split("|");
    }
  
    return typeof value === "string" ? value.split("|") : [];
  };

  console.log({answer})

  switch (answer?.type) {
    case "radio":
    case "select":
    case "checkbox":
    case "users":
      return (
        <FormRow>
          <SelectInput
            name={answer?.id}
            control={control}
            isSearchable={true}
            isClearable={true}
            resetFields={!values[answer?.id]}
            {...commonProps}
          />
        </FormRow>
      )
    case "textarea":
      return (
        <>
          <InputTextArea
            type="textarea"
            className="inputArea"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) =>
                  onChangeQuestionsInfo("textarea", e.target?.value, answer?.id, answer),
              })
            }
            hasFocus={true}
          />
        </>
      )
    case "date":
      return (
        <Input
          type="date"
          register={
            typeof register === "function" &&
            register(`${answer?.id}`, {
              onChange: (e) => onChangeQuestionsInfo("date", e.target?.value, answer?.id, answer),
            })
          }
          value={(values && values[answer?.id]) || ""}
        />
      )
    case "file":
      return (
        <div className="upload-button-evidence" style={{ display: "flex", gap: "12px" }}>
          
          <InputFileWithPreview
            name="files"
            accept="image/*,video/mp4"
            handleChangeFile={(e) => onChangeFile(e, (answer?.id || answer), formatFiles(values, answer))}
            handleRemoveFile={handleRemoveFile}
            uploaded={formatFiles(values, answer) || uploadedFiles[answer?.id || answer] || uploadedFiles}
            loadingProcessImage={loadingProcessImage === (answer?.id || answer)}
            isMultiple={true}
          />
        </div>
      )
    case "tel":
      return (
        <>
          <Input
            placeholder="(99) 9 9999-9999"
            type="text"
            register={
              typeof register === "function" &&
              register(`${answer?.id}`, {
                onChange: (e) => onChangeQuestionsInfo("tel", e.target?.value, answer?.id),
              })
            }
            value={(values && phoneMask(values[answer?.id])) || ""}
            min="14"
            max="15"
            {...(isMobile ? { ...{ type: "tel" } } : {})}
          />
        </>
      )
    case "datetime":
      return (
        <Input
          type="datetime-local"
          register={
            typeof register === "function" &&
            register(`${answer?.id}`, {
              onChange: (e) =>
                onChangeQuestionsInfo("dateTime", e.target?.value, answer?.id, answer),
            })
          }
          value={(values && values[answer?.id]) || ""}
          min="14"
          max="15"
        />
      )
    case "number":
      return (
        <Input
          type="number"
          register={
            typeof register === "function" &&
            register(`${answer?.id}`, {
              onChange: (e) => onChangeQuestionsInfo("number", numberMask(e.target?.value), answer?.id, answer),
            })
          }
          value={(values && values[answer?.id]) || ""}
          {...(isMobile ? { ...{ type: "tel" } } : {})}
        />
      )
    case "email":
      return (
        <Input
          type="email"
          register={
            typeof register === "function" &&
            register(`${answer?.id}`, {
              onChange: (e) => onChangeQuestionsInfo("email", e.target?.value, answer?.id, answer),
            })
          }
          value={(values && values[answer?.id]) || ""}
        />
      )
    default:
      return (
        <Input
          type="text"
          register={
            typeof register === "function" &&
            register(`${answer?.id}`, {
              onChange: (e) => onChangeQuestionsInfo("text", e.target?.value, answer?.id, answer),
            })
          }
          value={(values && values[answer?.id]) || ""}
        />
      )
  }
}
